@if (userData$ | async; as user) {
	<div class="container">
		<lawyal-side-bar
			class="container__side-bar"
			[notifications]="notifications"
			[notificationAdded]="notificationAdded"
			[notificationDeleted]="notificationDeleted"
			[selectedSideBarAction]="sideBarAction"
			[disabled]="!(settingsReadyState$ | async)"
			(actionClicked)="handleDrawerToggle($event)"
		></lawyal-side-bar>
		<new-drawer>
			<div class="container__nav-bar-and-router-outlet-wrapper">
				<lawyal-nav-bar
					class="container__nav-bar"
					[notifications]="notifications"
					[notificationAdded]="notificationAdded"
					[notificationDeleted]="notificationDeleted"
					(actionSelected)="handleNavBarAction($event)"
					(languageChanged)="changeLanguage()"
					[documentsManagement]="settings?.firm?.documents_management"
					[newMatter]="settings?.firm?.new_matter"
					[tasks]="settings?.firm?.lawyal_tasks"
				></lawyal-nav-bar>
				<div class="container__router-outlet-wrapper">
					@if ((settingsReadyState$ | async) && !isLoading) {
						<router-outlet></router-outlet>
					} @else {
						<mat-icon class="loader" svgIcon="loader"></mat-icon>
					}
					@if (!(phoneBreakPoint$ | async).matches) {
						@if (timers?.length) {
							<div class="container__timers-container">
								@for (timer of timers; track timer) {
									@if (timer.collapsed) {
										<lawyal-front-end-collapsed-timer
											class="collapsing-timer"
											[timerData]="timer"
											(startTimer)="startTimer($event)"
											(stopTimer)="stopTimer($event)"
											(expand)="openReportModalFromTimer($event)"
										></lawyal-front-end-collapsed-timer>
									}
								}
							</div>
						}
					}
				</div>
			</div>
		</new-drawer>
	</div>
}
